import React from 'react';
import PropTypes from 'prop-types';

export const Cases = ({ width, height, ...props }) => (
  <svg
    data-icon='cases'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M3 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 1 20V9h2v11h17v2H3Zm4-4c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 5 16V5h5V3c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 12 1h4c.55 0 1.02.196 1.413.587C17.803 1.98 18 2.45 18 3v2h5v11c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 21 18H7Zm0-2h14V7H7v9Zm5-11h4V3h-4v2Z'
    />
  </svg>
);

Cases.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Cases.defaultProps = {
  width: 24,
  height: 24,
};
